import React from 'react'
import campus from "../../assets/images/resource/project-10.jpg" ;
import office from '../../assets/images/background/office.jpg';
import photo from "../../assets/images/icons/kasahun.jpg";
import mekanisa2 from '../../assets/images/icons/mekanisa2.jpg';
import Dean from '../../assets/images/icons/teklay.jpg'
import MekeleStudent from  '../../assets/images/icons/mekelestudent.jpg'
import UnderlineWithIcon from '../components/UnderlineWithIcon';
const AdminOffice = () => {
  return (
    <div>
        
  
    <div className="banner-slide">
          <img src={office} alt="Banner 2" className="banner-image" />
          <div className="banner-content">
  <h2>EMPOWERING EXCELLENCE IN ADMINISTRATION AND FINANCE</h2>

</div>

        </div>

    <section class="projects-details">
      <h3 style={{textAlign:'center', marginBottom:'30px'}}>OFFICE OF THE VICE PRESIDENT FOR ADMINISTRATION AND FINANCE</h3>
		<UnderlineWithIcon/>
        <div class="auto-container">
            <div class="text-block">
                <div class="row">
                    <div class="col-lg-10">
                       
                        <div class="text">
                     
                       <p> The Office of the Vice President for Administration and Finance at Admas University is dedicated to fostering a robust and sustainable financial environment that supports our mission to be a premier private university in Ethiopia. Our strategic financial management ensures that we allocate resources effectively, enhancing academic programs and student services. Elevating Admas University: A Leader in Ethiopian Higher Education    </p>
                                                   
                        </div>
                    </div>
                   
                </div>
               </div>
            <div class="text-block">
                <div class="row">
                    <div class="col-lg-6">
                    <div className="sec-title style-two">
              <h4>MEET THE VICE PRESIDENT FOR ADMINISTRATION AND FINANCE</h4>
            </div>
            <div>
              <p>
             Ato Kasahun Amare has been working for more than Twenty-Two years in Private Higher Education Institutions. He has MSc degree in Developmental Psychology and BSc in Business Education from Addis Ababa University.  Ato Kasahun has worked  in various positions: Vice President for Admin & Finance, Vice President for Admin, Finance and Business Development, Campus Dean, Academic Department Head and Instructor.      </p>
            </div>
        
                    </div>
                    <div class="col-lg-4">
                        <div class="image"><img src={photo} alt=""/></div>
                        <p className='designation' >Kassahun Amare</p>

                    </div>
                </div>
            </div>
           <hr/>
            <div class="text-block-two">
                <div class="row">
                    <div class="col-lg-12">
                        <h4>KEY RESPONSIBILITIES:</h4>
                        <div class="text">
                        The Office of the President is dedicated to several key initiatives that enhance our university's impact:                        </div>
                      <ul className="services-list">
                    <li><div className="icon-box"><span className="flaticon-book"></span> Financial Oversight: Implementing efficient budgetary practices to maximize funding for academic excellence.</div></li>
                      <li><div className="icon-box"><span className="flaticon-book"></span>Resource Management: Ensuring optimal allocation of resources to support innovative teaching and research.</div></li>
                      <li><div className="icon-box"><span className="flaticon-book"></span>Operational Efficiency: Streamlining administrative processes to enhance overall university performance.</div></li>
                     </ul>
                    </div>
                 
                </div>
            </div>

            <hr/>
            <div class="text-block-two">
                <div class="row">
                    <div class="col-lg-10">
                        <h4>COMMITMENT TO EXCELLENCE</h4>
                        <div class="text">
                   <p>
                   Our commitment to transparency and accountability positions Admas University as a trusted institution in Ethiopia's educational landscape. By prioritizing financial integrity, we aim to continually improve our rankings and provide exceptional value to our students.
                   </p>
                    </div>
                 
                </div>
            </div>
        </div>

        <hr/>
        <div class="text-block-two">
                <div class="row">
                    <div class="col-lg-10">
                        <h4>CONTACT US</h4>
                        <div class="text">
   <p>
   Explore how the Office of the Vice President for Administration and Finance is shaping the future of Admas University, making it a leading choice for students seeking quality private education in Ethiopia.
   </p>
   For more information or inquiries, please reach out to the Office of the President: 
                        Email: kasahunA@admasuniversity.edu.et
Phone: +251 123 456 789
Office Location: Olympia, 603, Admas University
   </div>
                 
                 </div>
             </div>
         </div>

     
      
</div>

    </section>
    </div>
  )
}

export default AdminOffice